class CanvyraLanguageSwitcher extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.cvy-lang__toggle');
    this.panel = this.querySelector('.cvy-lang__panel');
    if (!this.toggle || !this.panel) return;

    this.toggle.addEventListener('click', this.#onToggle);
    document.addEventListener('click', this.#onDocumentClick);
    document.addEventListener('keydown', this.#onKeydown);
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.#onToggle);
    document.removeEventListener('click', this.#onDocumentClick);
    document.removeEventListener('keydown', this.#onKeydown);
  }

  #onToggle = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const isOpen = this.toggle.getAttribute('aria-expanded') === 'true';
    this.#setOpen(!isOpen);
  };

  #onDocumentClick = (event) => {
    if (!this.contains(event.target)) {
      this.#setOpen(false);
    }
  };

  #onKeydown = (event) => {
    if (event.key === 'Escape') {
      this.#setOpen(false);
    }
  };

  #setOpen(open) {
    this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    this.panel.hidden = !open;
    this.classList.toggle('is-open', open);
  }
}

if (!customElements.get('canvyra-language-switcher')) {
  customElements.define('canvyra-language-switcher', CanvyraLanguageSwitcher);
}
